'use client';

import { useTranslations } from 'next-intl';
import { useGamesList } from '../../../context/GamesListProvider/GamesListProvider';

/**
 * GamesCountLabel component is atomic component that displays the games count label
 * It uses the useGamesList hook to get the games counter and the is games loading state
 * Has to be used inside the GamesListProvider component, but it's not expected to be used outside CasinoCategoryPageControls
 * @returns The games count label
 */
function GamesCountLabel() {
  const t = useTranslations('casino.secondary_header');
  const { gamesCounter, isGamesLoading } = useGamesList();

  return !isGamesLoading ? t('games_count_label', { count: gamesCounter }) : null;
}

export { GamesCountLabel };
